import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../../forms/FormMixin'
import { useConfirm } from '@/composables/useConfirm'
import { useUserStore } from '@/stores/user'
import useField from '@/composables/useField'
import { optionsGetter } from '@utils/helpers'
import { useModalOpener } from '@/composables/useModalOpener'
import { useTransactions } from '@/stores/transactions'
import {
  transactionsUpdateResource,
  transactionsToggleActivationResource,
  transactionsChangeStatusResource,
} from '@/services/transactions.service'
  
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionInInvoiceEditModal',
  props: {
  promise: Promise,
  close: Function,
  info: Object,
},
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const formIsChanged = ref(false)

const emit = __emit
const { $t } = useGlobal()
const load = ref(false) 
const dataIsSended = ref(false)
const form = ref({
  id: '',
  inInvoice: '',
})

const question = $t('Сonfirm action')

watch(() => props.info, () => {
  Object.keys(form.value).forEach(key => {
    if(props.info[key]) form.value[key] = props.info[key]
  })
}, {immediate: true, deep: true})

watch(() => form.value, () => {
  formIsChanged.value = true
}, { deep: true})

const fields = ref([
  useField('inInvoice', $t('Invoice indicator'), {
    component: 'd-control-multiselect',
    options: '',
    'show-labels': false,
    'track-by': 'value',
    'label-by': 'label',
    'allow-empty': false,
    cols: 'g-cols--12',
    optionsTypeTitle: 'in_invoice',
  }),
])

const request = (sendData: any, control: any) => {
  useSubmit( send(sendData, control), control)
}

const send = async (sendData: any, control: any) => {
  const preparedData = {
    ...sendData,
  }
  preparedData.inInvoice = preparedData?.inInvoice?.value
  const title = $t('Successfully')
  const subtitle = $t('All data is saved')
  try {
      await useConfirm(question)
      load.value = true
    
      await transactionsUpdateResource.execute({ id: form.value?.id }, {
        ...preparedData,
      })
      load.value = false
      await useModalOpener({
      component: 'UiMessageModal',
      message:{
        title,
        subtitle,
        success: true,
        },
      })
      props.promise(true)
      props.close()
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}
  
const __returned__ = { props, formIsChanged, emit, $t, load, dataIsSended, form, question, fields, request, send, ref, computed, watch, get useSubmit() { return useSubmit }, get useConfirm() { return useConfirm }, get useUserStore() { return useUserStore }, get useField() { return useField }, get optionsGetter() { return optionsGetter }, get useModalOpener() { return useModalOpener }, get useTransactions() { return useTransactions }, get transactionsUpdateResource() { return transactionsUpdateResource }, get transactionsToggleActivationResource() { return transactionsToggleActivationResource }, get transactionsChangeStatusResource() { return transactionsChangeStatusResource }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})